export const types = [
  {
    iso: "wholesaler",
    name: "Wholesaler",
  },
  {
    iso: "retailer",
    name: "Retailer",
  },
  {
    iso: "garage",
    name: "Specialised garage",
  },
  {
    iso: "other",
    name: "Other",
  },
];

export const customers = [
  {
    iso: "individual",
    name: "Individual car owners",
  },
  {
    iso: "retail",
    name: "Garages and retail outlets",
  },
];

export const specialisations = [
  {
    iso: "makes",
    name: "Vehicle makes",
  },
  {
    iso: "parts",
    name: "Certain parts only",
  },
  {
    iso: "other",
    name: "Other",
  },
];

export const areas = [
  {
    iso: "local",
    name: "Local area",
  },
  {
    iso: "country",
    name: "Entire country",
  },
  {
    iso: "outside",
    name: "Sell outside of country",
  },
];

export const willStocks = [
  {
    iso: "yes",
    name: "Yes",
  },
  {
    iso: "no",
    name: "No",
  },
];
